<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <section id="ngx-datatable-shipping">
      <div class="card">
        <div class="card-title d-flex justify-content-between align-items-center">
          <h4>Cierres de Envíos</h4>
          <button class="btn btn-primary" rippleEffect [routerLink]="['/pages/shipping-balance-create']">
            <i data-feather="plus" class="mr-0 mr-sm-1"></i><span class="d-none d-sm-inline-block">Nuevo Cierre</span>
          </button>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 col-12">
              <div class="d-flex justify-content-between align-items-center m-1">
                <label class="d-flex align-items-center">Mostrando
                  <select class="form-control mx-25" [(ngModel)]="basicSelectedOption">
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option *ngIf="balances.length > 15" [value]="balances.length">Todos</option>
                  </select>
                  cierres</label>
              </div>
            </div>
            <div class="col-md-6 col-12 d-flex justify-content-md-end">
              <div class="d-flex align-items-center justify-content-end pr-1 pb-1 pl-1 pl-md-0 pb-md-0">
                <label class="d-flex align-items-center">Buscar<input #searchInput type="search"
                    placeholder="Código Factura" class="form-control ml-25" (keyup)="FilterUpdate(searchInput.value)"
                    (search)="FilterUpdate(searchInput.value)" /></label>
              </div>
            </div>
          </div>
          <ngx-datatable [rows]="balances" [rowHeight]="58" class="bootstrap core-bootstrap"
            [columnMode]="ColumnMode.force" [headerHeight]="40" [footerHeight]="50" [scrollbarH]="true"
            [limit]="basicSelectedOption" [messages]="{
              emptyMessage: 'No hay información para mostrar',
              totalMessage: 'Total de cierres'
            }">
            <ngx-datatable-column name="Envío" prop="shippingCode"></ngx-datatable-column>
            <ngx-datatable-column name="# Facturas" prop="billsTotal"></ngx-datatable-column>
            <ngx-datatable-column name="$ Facturas" prop="billsCost"></ngx-datatable-column>
            <ngx-datatable-column name="Fecha" prop="createdAt">
              <ng-template let-createdAt="value" ngx-datatable-cell-template>
                <span>{{ createdAt | date : "mediumDate" }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Acciones" [width]="200" [sortable]="false" prop="id">
              <ng-template ngx-datatable-cell-template let-billId="value">
                <button class="btn btn-outline-light text-primary dropbtn" [ngbPopover]="popoverTemplate" #popOver="ngbPopover"
                  data-container="body" placement="left-top" [autoClose]="'outside'" type="button" id="defaultDropdown"
                  aria-expanded="false">
                  <em class="fa fa-bars"></em>
                </button>
                <ng-template #popoverTemplate style="overflow: visible;">
                  <div>
                    <button type="button" ngbTooltip="Ver detalles" placement="left"
                      class="btn btn-icon btn-outline-success text-success cursor-pointer mr-50" rippleEffect
                      (click)="SeeDetails(billId)">
                      <span [data-feather]="'eye'"></span>
                    </button>
                    <button type="button" ngbTooltip="Eliminar" placement="left"
                      class="btn btn-icon btn-outline-danger text-danger cursor-pointer mr-50" rippleEffect
                      (click)="DeleteBalance(billId)">
                      <span [data-feather]="'trash-2'"></span>
                    </button>
                  </div>
                </ng-template></ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
    </section>
  </div>
</div>